export default "__VITE_ASSET__DoII_qrK__"